
export const mockFooterBottom = {   
    enlaces:[
        {
            texto: "Accesibilidad"
        },
        {
            texto: "Aviso legal",
            link: "https://www.juntadeandalucia.es/informacion/legal.html"
        },
        {
            texto: "Protección de datos",
            link: "https://www.juntadeandalucia.es/protecciondedatos.html"
        }
        
    ],
    iconos:[
        {
            alt: "Logotipo Junta de Andalucía",
            src: "images/JJAA/marcaGenerica.svg"
        },
        {
            alt: "Logotipo Andalucía Origen y Destino",
            src: "images/JJAA/origenYDestino.svg"
        },
        {
            alt: "Logotipo Agenda 2030",
            src: "images/JJAA/agenda2030.svg"
        }
    ]
}